export default "__VITE_ASSET__DlgowQRI__"